import { Select, SelectProps } from 'antd';
import './index.scss';

interface CustomSelectProps<T = any> extends SelectProps<T> {
  useParentPopupContainer?: boolean;
}

const CustomSelect = <T extends any>(props: CustomSelectProps<T>) => {
  const { className, placeholder, suffixIcon, useParentPopupContainer = true, ...rest } = props;

  return (
    <Select<T>
      {...rest}
      className={`ant-custom-select ${className || ''}`}
      getPopupContainer={useParentPopupContainer ? (trigger: any) => trigger.parentNode : undefined}
      placeholder={placeholder || undefined}
      suffixIcon={suffixIcon}
    />
  );
};

export default CustomSelect;
